// STG
export const DataMerchantChatID_STG = [
    {
        "id": 1,
        "chat_id": "-5250622326",
        "room_name": "test1",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 2,
        "chat_id": "-5116981036",
        "room_name": "test2",
        "channel": "telegram",
        "status": 1,
    },
];

// PROD
export const DataMerchantChatID = [
    {
        "id": 1,
        "chat_id": "-1004470757277",
        "room_name": "PAYEASY SUPPORT",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 2,
        "chat_id": "-5282020327",
        "room_name": "Payeasy - Marinabays",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 3,
        "chat_id": "-5052331006",
        "room_name": "Payment integration",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 4,
        "chat_id": "-5042673784",
        "room_name": "Payeasy - Happyxbet",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 5,
        "chat_id": "-5259059595",
        "room_name": "Payeasy - Superwinway",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 6,
        "chat_id": "-5078504243",
        "room_name": "Payeasy - Allwaysbet",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 7,
        "chat_id": "-4864246870",
        "room_name": "Payeasy - Inspire",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 8,
        "chat_id": "-4937615245",
        "room_name": "Payeasy - Crown",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 9,
        "chat_id": "-5073846133",
        "room_name": "Payeasy - Grandsroyal",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 10,
        "chat_id": "-4800180578",
        "room_name": "Payeasy - Kingwinn",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 11,
        "chat_id": "-4845216499",
        "room_name": "Payeasy - Grandmadrid",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 12,
        "chat_id": "-5136193271",
        "room_name": "Payeasy - Valencyclub",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 13,
        "chat_id": "-5051785325",
        "room_name": "Payeasy - Hyper189",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 14,
        "chat_id": "-4850294435",
        "room_name": "Payeasy - eazyxbet",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 15,
        "chat_id": "-5267279735",
        "room_name": "Support บช บริษัท ฝั่งพี่ออฟ",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 16,
        "chat_id": "-1003951462576",
        "room_name": "Payeasy - 24hoursbets",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 17,
        "chat_id": "-1004290903067",
        "room_name": "Payeasy - blacknova",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 18,
        "chat_id": "-4972769274",
        "room_name": "Payeasy - Satudio",
        "channel": "telegram",
        "status": 1,
    },
    {
        "id": 19,
        "chat_id": "-1002832056925",
        "room_name": "Payeasy - Tigerxxx",
        "channel": "telegram",
        "status": 1,
    },
];
